<template>
  <div>
    <!-- Section 1: Header Banner -->
    <div
      class="section-header-gradient py-[24px] px-[24px] text-center text-white"
    >
      <div class="text-[18px] font-normal leading-[22px]">Switch To</div>
      <div class="text-[28px] font-bold leading-[34px]">
        ORAL-B ELECTRIC<br />TOOTHBRUSH!
      </div>
    </div>

    <!-- Section 2: Buy Now Products (inline) -->
    <div id="buy-now" class="buy-now-bg">
      <div class="flex justify-center gap-[8px] px-[24px] pt-[32px] pb-[32px]">
        <div
          v-for="product in products"
          :key="product.name"
          class="flex-1 flex flex-col"
        >
          <div class="overflow-hidden border border-white/20 mb-[8px]">
            <img
              :src="product.image"
              :alt="product.name"
              class="w-full object-cover"
            />
          </div>
          <a
            :href="product.link"
            target="_blank"
            rel="noreferrer noopener"
            class="block w-full py-[10px] text-center text-[11px] font-bold text-[#01132B] bg-white mb-[8px]"
            @click="trackProductClick(product.link)"
          >
            BUY NOW
          </a>
          <div
            class="w-full py-[8px] text-center text-[10px] font-bold text-white"
            style="background: #0055a6"
          >
            {{ product.code }}
          </div>
        </div>
      </div>
    </div>

    <!-- Section 3: Money-back Guarantee -->
    <div>
      <img
        src="@/assets/images/money-back-guarantee.png"
        alt="Try it, love it, or get your money back. YES, ALL OF IT! 100% money-back guarantee"
        class="w-full"
      />
    </div>

    <!-- Section 4: Action Buttons -->
    <div class="py-[28px] px-[40px] bg-white">
      <div class="text-[16px] font-bold mb-[24px] text-[#0F5C9A] text-center">
        What Do You Wish To Do?
      </div>
      <div class="flex flex-col items-center space-y-[16px]">
        <button class="cta-btn" @click="scrollTo('buy-now')">BUY NOW</button>
        <button class="cta-btn" @click="scrollTo('io9-video')">
          LEARN MORE
        </button>
        <a
          :href="browseMoreLink"
          class="cta-btn text-center"
          rel="noreferrer noopener"
          target="_blank"
          @click="trackLinkClick"
        >
          BROWSE ALL PRODUCTS
        </a>
        <button class="cta-btn" @click="$emit('next')">
          FILL YOUR REFUND REQUEST
        </button>
        <button class="cta-btn" @click="scrollTo('troubleshooting')">
          USER SUPPORT
        </button>
      </div>
    </div>

    <!-- Section 7: Why Electric Header -->
    <div class="section-header-gradient py-[11px] text-center text-white">
      <div class="text-[16px] font-semibold leading-[19.5px]">
        Why is an Electric Toothbrush Better<br />Than a Manual One?
      </div>
    </div>

    <!-- Section 7b: Why Electric Thumbnails -->
    <div class="why-electric-bg">
      <div class="flex justify-center gap-[42px] py-[14px]">
        <div class="thumbnail-card">
          <div class="video-wrapper" @click="toggleVideo('c5')">
            <video
              ref="c5Video"
              src="@/assets/images/c5-hook.mp4"
              :poster="c5Poster"
              playsinline
              preload="metadata"
              class="w-full h-full object-cover"
              @play="videoPlaying.c5 = true"
              @pause="videoPlaying.c5 = false"
              @ended="videoPlaying.c5 = false"
            ></video>
            <div v-show="!videoPlaying.c5" class="play-overlay">
              <div class="play-btn">
                <svg viewBox="0 0 24 24" fill="white">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="thumbnail-card">
          <div class="video-wrapper" @click="toggleVideo('io3')">
            <video
              ref="io3Video"
              src="@/assets/images/io3-experience.mp4"
              :poster="io3Poster"
              playsinline
              preload="metadata"
              class="w-full h-full object-cover"
              @play="videoPlaying.io3 = true"
              @pause="videoPlaying.io3 = false"
              @ended="videoPlaying.io3 = false"
            ></video>
            <div v-show="!videoPlaying.io3" class="play-overlay">
              <div class="play-btn">
                <svg viewBox="0 0 24 24" fill="white">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 8: Look at the Difference -->
    <div class="py-[10px] text-center bg-white">
      <div class="text-[15.95px] font-normal leading-[19.44px] text-[#0F5C9A]">
        Still not convinced?
      </div>
      <div
        class="text-[21.31px] font-bold leading-[25.98px] text-[#0F5C9A] mt-[4px]"
      >
        LOOK AT THE DIFFERENCE!
      </div>
    </div>

    <!-- Section 8b: Brush Comparison GIF -->
    <img
      src="@/assets/images/last-tooth.gif"
      alt="A perfect clean, even on your last tooth"
      class="w-full block"
    />

    <!-- Brand Badge + Hero Series 9 -->
    <div class="section-header-gradient py-[16px] px-[51px] text-center">
      <div class="text-[16px] font-bold leading-[19.5px] text-white">
        WE'RE THE #1 DENTIST RECOMMENDED<br />BRAND FOR A REASON
      </div>
    </div>
    <img
      src="@/assets/images/hero-series9.png"
      class="w-full"
      alt="Oral-B iO Series 9 - The Future of Brushing is Here"
    />

    <!-- Divider -->
    <div class="section-header-gradient py-[24px]"></div>

    <!-- Section 9: Oral-B iO Video -->
    <div id="io9-video">
      <div
        class="video-wrapper video-wrapper--landscape"
        @click="toggleVideo('io9')"
      >
        <video
          ref="io9Video"
          :poster="io9Poster"
          playsinline
          preload="metadata"
          class="w-full block"
          @play="videoPlaying.io9 = true"
          @pause="videoPlaying.io9 = false"
          @ended="videoPlaying.io9 = false"
        >
          <source src="../assets/images/io9-video.mp4" type="video/mp4" />
        </video>
        <div v-show="!videoPlaying.io9" class="play-overlay">
          <div class="play-btn play-btn--lg">
            <svg viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 10: Customer Reviews -->
    <div class="section-header-gradient py-[16px] px-[51px] text-center">
      <div class="text-[20px] font-bold leading-[24px] text-white">
        Why Customers Love Us!
      </div>
    </div>
    <div>
      <img
        src="@/assets/images/customer-reviews.gif"
        alt="Customer reviews - Best gift ever, 10 out of 10 recommended"
        class="w-full"
      />
    </div>

    <!-- Section 11: Product Comparison (LEARN MORE target) -->
    <div id="product-comparison">
      <div class="section-header-gradient py-[20px] px-[51px] text-center">
        <div class="text-[16px] font-semibold leading-[19.5px] text-white">
          CONFUSED ON WHAT TO BUY?<br />WE'LL HELP YOU CHOOSE!
        </div>
      </div>
      <div class="relative px-[40px] pb-6 bg-white">
        <carousel
          :items-to-show="1"
          :wrap-around="true"
          :autoplay="3000"
          :pause-autoplay-on-hover="true"
          v-model="comparisonSlide"
        >
          <slide v-for="(img, idx) in highlightStories" :key="`hs-${idx}`">
            <div class="px-2 pt-4">
              <img
                :src="img"
                :alt="`Product comparison ${idx + 1}`"
                class="w-full"
              />
            </div>
          </slide>
        </carousel>
        <button
          class="carousel-arrow carousel-arrow--left"
          aria-label="Previous slide"
          @click="
            comparisonSlide =
              comparisonSlide > 0
                ? comparisonSlide - 1
                : highlightStories.length - 1
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </button>
        <button
          class="carousel-arrow carousel-arrow--right"
          aria-label="Next slide"
          @click="
            comparisonSlide =
              comparisonSlide < highlightStories.length - 1
                ? comparisonSlide + 1
                : 0
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Section 12: Troubleshooting (USER SUPPORT target) -->
    <div id="troubleshooting">
      <div class="section-header-gradient py-[20px] px-[51px] text-center">
        <div class="text-[16px] font-semibold leading-[19.5px] text-white">
          Having trouble with your Oral-B Brush?
        </div>
      </div>
      <div class="relative px-[40px] pb-6 bg-white">
        <carousel
          :items-to-show="1"
          :wrap-around="true"
          :autoplay="3000"
          :pause-autoplay-on-hover="true"
          v-model="troubleshootSlide"
        >
          <slide v-for="(img, idx) in productRangeSlides" :key="`pr-${idx}`">
            <div class="px-2 pt-4">
              <img
                :src="img"
                :alt="`Troubleshooting step ${idx + 1}`"
                class="w-full"
              />
            </div>
          </slide>
        </carousel>
        <button
          class="carousel-arrow carousel-arrow--left"
          aria-label="Previous slide"
          @click="
            troubleshootSlide =
              troubleshootSlide > 0
                ? troubleshootSlide - 1
                : productRangeSlides.length - 1
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </button>
        <button
          class="carousel-arrow carousel-arrow--right"
          aria-label="Next slide"
          @click="
            troubleshootSlide =
              troubleshootSlide < productRangeSlides.length - 1
                ? troubleshootSlide + 1
                : 0
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Section 13: Footer -->
    <div class="footer-gradient px-[25px] py-[10px]">
      <div
        class="text-[7.82px] font-bold leading-[11.72px] text-white mb-[6px]"
      >
        &copy; 2025 Procter &amp; Gamble
      </div>
      <div class="text-white footer__links">
        <a
          class="text-white underline text-[7.82px] leading-[11.72px]"
          href="https://termsandconditions.pg.com/en-in/#use"
          target="_blank"
          rel="noreferrer"
          >Terms &amp; Conditions</a
        >
        <a
          class="text-white underline text-[7.82px] leading-[11.72px]"
          href="https://privacypolicy.pg.com/en-IN/"
          target="_blank"
          rel="noreferrer"
          >Privacy</a
        >
        <a
          class="text-white underline text-[7.82px] leading-[11.72px]"
          href="https://privacypolicy.pg.com/en-IN/"
          target="_blank"
          rel="noreferrer"
          >AdChoices</a
        >
        <a
          class="flex items-center text-white text-[7.82px] leading-[11.72px]"
          target="_blank"
          href="https://preferencecenter.pg.com/en-in/"
        >
          Your Privacy Choices
          <span>
            <img
              src="@/assets/images/privacy.svg"
              alt="Your Privacy Choices"
              class="privacy-icon"
            />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import axios from 'axios'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

// Video poster images
import c5Poster from '@/assets/images/c5-hook-poster.jpg'
import io3Poster from '@/assets/images/io3-experience-poster.jpg'
import io9Poster from '@/assets/images/io9-video-poster.jpg'

// Product images for Buy Now section
import io9Img from '@/assets/images/io9.png'
import io3Img from '@/assets/images/io3.png'
import pro3Img from '@/assets/images/pro3.png'

// Product comparison images
import hs1 from '@/assets/images/highlight-story-1.png'
import hs2 from '@/assets/images/highlight-story-2.png'
import hs3 from '@/assets/images/highlight-story-3.png'
import hs4 from '@/assets/images/highlight-story-4.png'
import hs5 from '@/assets/images/highlight-story-5.png'
import hs6 from '@/assets/images/highlight-story-6.png'
import hs7 from '@/assets/images/highlight-story-7.png'

// Troubleshooting images
import pr1 from '@/assets/images/product-range-1.png'
import pr2 from '@/assets/images/product-range-2.png'
import pr3 from '@/assets/images/product-range-3.png'
import pr4 from '@/assets/images/product-range-4.png'
import pr5 from '@/assets/images/product-range-5.png'
import pr6 from '@/assets/images/product-range-6.png'

const products = [
  {
    name: 'Oral-B iO9',
    image: io9Img,
    link: 'https://www.amazon.in/dp/B0DFWC4XH9',
    code: 'IO9MUMBAI',
  },
  {
    name: 'Oral-B iO3',
    image: io3Img,
    link: 'https://www.amazon.in/dp/B0C1H5CFSX',
    code: 'IO3MUMBAI',
  },
  {
    name: 'Oral-B Pro 3',
    image: pro3Img,
    link: 'https://www.amazon.in/dp/B094W9Z82F',
    code: 'PRO3MUMBAI',
  },
]

const browseMoreLink =
  'https://www.amazon.in/stores/page/368C51AC-6B7A-46EE-8567-46D5EF418614/?_encoding=UTF8&pd_rd_plhdr=t&pd_rd_i=B088N6KHH8&store_ref=SBV_A0365866HZN1QY9K2ZAJ-A06472223W3G4867V6MBJ&lp_asins=B088N6KHH8,B0BP1PXYQN,B094W9Z82F&pd_rd_w=gW24U&content-id=amzn1.sym.df9fe057-524b-4172-ac34-9a1b3c4e647d:amzn1.sym.df9fe057-524b-4172-ac34-9a1b3c4e647d&pf_rd_p=df9fe057-524b-4172-ac34-9a1b3c4e647d&pf_rd_r=E6N1ZDFY9VQ0917FE2V6&pd_rd_wg=U3pGG&pd_rd_r=375ba1ef-8445-4986-8770-16598bc07b38'

function trackProductClick(link) {
  axios
    .get('/safalta-app/oralb-moneyback/api/track-link-click', {
      params: { link },
    })
    .catch(() => {})
}

function trackLinkClick() {
  axios
    .get('/safalta-app/oralb-moneyback/api/track-link-click', {
      params: { link: browseMoreLink },
    })
    .catch(() => {})
}

function scrollTo(id) {
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}

// Video refs and state
const c5Video = ref(null)
const io3Video = ref(null)
const io9Video = ref(null)
const videoPlaying = reactive({ c5: false, io3: false, io9: false })

const videoRefs = { c5: c5Video, io3: io3Video, io9: io9Video }

function toggleVideo(key) {
  const video = videoRefs[key].value
  if (!video) return
  if (video.paused) {
    // Pause other videos first
    Object.keys(videoRefs).forEach((k) => {
      if (k !== key && videoRefs[k].value && !videoRefs[k].value.paused) {
        videoRefs[k].value.pause()
      }
    })
    video.play()
  } else {
    video.pause()
  }
}

const comparisonSlide = ref(0)
const troubleshootSlide = ref(0)

const highlightStories = [hs1, hs2, hs3, hs4, hs5, hs6, hs7]
const productRangeSlides = [pr1, pr2, pr3, pr4, pr5, pr6]
</script>

<style scoped>
/* Gradient used on section headers: #092C5F → #10609B */
.section-header-gradient {
  background: linear-gradient(180deg, #092c5f 0%, #10609b 100%);
}

/* Footer gradient: #1C5991 → #081E3D */
.footer-gradient {
  background: linear-gradient(180deg, #1c5991 0%, #081e3d 100%);
}

/* Buy Now section background */
.buy-now-bg {
  background-color: #01132b;
}

/* Why Electric dark background */
.why-electric-bg {
  background-color: #01132b;
}

/* Thumbnail cards: 120x214px */
.thumbnail-card {
  width: 160px;
  height: 280px;
  flex-shrink: 0;
  border: 2px solid #2a5a8a;
  overflow: hidden;
}

/* CTA Buttons: full-width, #0055A6, pill shape, 14px/700 */
.cta-btn {
  width: 100%;
  height: 48px;
  background-color: #0055a6;
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  border-radius: 0;
  padding: 14px 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

/* Footer links grid */
.footer__links {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.privacy-icon {
  width: 12px;
  margin-left: 4px;
}

/* Carousel arrow buttons */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #05365e;
  cursor: pointer;
  z-index: 10;
  padding: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-arrow svg {
  width: 24px;
  height: 24px;
}

.carousel-arrow--left {
  left: 6px;
}

.carousel-arrow--right {
  right: 6px;
}

/* Video play overlay */
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.video-wrapper--landscape {
  height: auto;
}

.play-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.15);
}

.play-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-btn svg {
  width: 26px;
  height: 26px;
  margin-left: 3px;
}

.play-btn--lg {
  width: 72px;
  height: 72px;
}

.play-btn--lg svg {
  width: 36px;
  height: 36px;
  margin-left: 4px;
}
</style>
